export const buildProvenance = { "commitHash": "955af00220e244d05968b58dcec02456fda47380", "branchName": "refs/heads/release/2023.2", "buildDate": "2023-07-21T13:34:45.354Z", "version": "2023.2.13113" };
